.name {
    font: var(--bi-font-label-large);
    margin-top: var(--bi-scale-3x);

    @media (width < 768px) {
        margin-top: var(--bi-scale-2x);
    }
}

.academicDegree {
    font: var(--bi-font-body-medium);
    color: var(--bi-color-text-secondary);
}

.readMore {
    display: flex;
    align-items: center;
    gap: var(--bi-scale-2x);
    margin-top: var(--bi-scale-4x);
    font-weight: var(--bi-font-weight-bold);

    @media (width < 768px) {
        margin-top: var(--bi-scale-2x);
    }

    > svg {
        transition: transform 200ms ease-in-out;
    }

    @media (hover: hover) and (pointer: fine) {
        :global(.promo-card):has(:global(.\:click-delegate-hover)) & > svg {
            transform: translateX(var(--bi-scale-1x));
        }
    }
}
